import {
  Box,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  Text,
} from "@chakra-ui/react";
import { InfoCircle } from "iconsax-react";

// EG-38 (passo 4 BI) — botão de info consistente: explica, em palavras, o que a
// página mostra e como ler os gráficos. Público não técnico se orienta sem
// depender de saber ler visualização.
export default function InfoButton({ title, children }) {
  return (
    <Popover placement="bottom-end" strategy="fixed">
      <PopoverTrigger>
        <IconButton
          aria-label={title || "Informações"}
          icon={<InfoCircle size="20" color="#0073BB" />}
          variant="ghost"
          size="sm"
          borderRadius="full"
        />
      </PopoverTrigger>
      <Portal>
        <PopoverContent maxW="360px" boxShadow="lg" borderColor="#E2E8F0">
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader fontWeight={700} fontSize="14px" color="#292B30">
            {title}
          </PopoverHeader>
          <PopoverBody>
            <Box fontSize="13px" color="#5C6066" lineHeight="1.5">
              {typeof children === "string" ? <Text>{children}</Text> : children}
            </Box>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}
